import { FC} from 'react';
import { createProperties } from '../../../fetch/imports';
import { UploadHandler } from '../../../components/import/uploadHandler';

export const ImportProperties: FC = () => {
  return (
  <UploadHandler 
    title='Import Properties'
    loaderMessage='Importing Properties ...'
    createEndpoint={createProperties}/>
    )
};